import React from 'react'
import './service.css'
import { GrReactjs } from 'react-icons/gr'
import ScrollReveal from '../shared/ScrollReveal'
import { CiMobile3 } from 'react-icons/ci'
import { SiWeb3Dotjs } from 'react-icons/si'
import { BiPaint } from 'react-icons/bi'
import { FiCoffee } from 'react-icons/fi'
import { GiMountaintop } from 'react-icons/gi'
import { useLanguage } from '../../context/LanguageContext'

const Services = () => {
  const { t } = useLanguage()
  const items = t.services.items
  return (
    <div className='container services__container'>
      <div className="services__entete">
        <h2 id="Services" className="services__entete--title">
          {t.services.title}
        </h2>
        <div className="services__entete--text">
          <p>{t.services.desc}</p>
        </div>
      </div>

      <div className="services__main--container">
        <ScrollReveal delay={0} className='services__main--content services-card--dev'>
          <div className="services__main--title">
            <div className='s__main-levitate'>
              <GrReactjs className='s__main-icons'/>
            </div>
            <h4>{items[0].title}</h4>
          </div>
          <div className="services__main--text">
            <p>{items[0].text}</p>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={100} className='services__main--content services-card--resp'>
          <div className="services__main--title">
            <CiMobile3 className='s__main-levitate'/>
            <h4>{items[1].title}</h4>
          </div>
          <div className="services__main--text">
            <p>{items[1].text}</p>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={200} className='services__main--content services-card--webdes'>
          <div className="services__main--title">
            <SiWeb3Dotjs className='s__main-levitate'/>
            <h4>{items[2].title}</h4>
          </div>
          <div className="services__main--text">
            <p>{items[2].text}</p>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0} className='services__main--content services-card--creative'>
          <div className="services__main--title">
            <BiPaint className='s__main-levitate' />
            <h4>{items[3].title}</h4>
          </div>
          <div className="services__main--text">
            <p>{items[3].text}</p>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={100} className='services__main--content services-card--support'>
          <div className="services__main--title">
            <FiCoffee className='s__main-levitate' />
            <h4>{items[4].title}</h4>
          </div>
          <div className="services__main--text">
            <p>{items[4].text}</p>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={200} className='services__main--content services-card--brand'>
          <div className="services__main--title">
            <GiMountaintop className='s__main-levitate' />
            <h4>{items[5].title}</h4>
          </div>
          <div className="services__main--text">
            <p>{items[5].text}</p>
          </div>
        </ScrollReveal>

      </div>
    </div>
  )
}

export default Services